"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProfileComplete = exports.PayoutAccountType = exports.TravelInterest = exports.ContentCategory = exports.Language = exports.UserType = exports.Sex = void 0;
var Sex;
(function (Sex) {
    Sex["Male"] = "Male";
    Sex["Female"] = "Female";
    Sex["Other"] = "Other";
})(Sex = exports.Sex || (exports.Sex = {}));
var UserType;
(function (UserType) {
    UserType["Creator"] = "creator";
    UserType["Agency"] = "agency";
    UserType["Admin"] = "admin";
})(UserType = exports.UserType || (exports.UserType = {}));
var Language;
(function (Language) {
    Language["English"] = "English";
    Language["Afrikaans"] = "Afrikaans";
    Language["Albanian"] = "Albanian";
    Language["Amharic"] = "Amharic";
    Language["Arabic"] = "Arabic";
    Language["Armenian"] = "Armenian";
    Language["Azerbaijani"] = "Azerbaijani";
    Language["Basque"] = "Basque";
    Language["Belarusian"] = "Belarusian";
    Language["Bengali"] = "Bengali";
    Language["Bosnian"] = "Bosnian";
    Language["Bulgarian"] = "Bulgarian";
    Language["Burmese"] = "Burmese";
    Language["Catalan"] = "Catalan";
    Language["Cebuano"] = "Cebuano";
    Language["Chichewa"] = "Chichewa";
    Language["ChineseSimplified"] = "Chinese (Simplified)";
    Language["ChineseTraditional"] = "Chinese (Traditional)";
    Language["Corsican"] = "Corsican";
    Language["Croatian"] = "Croatian";
    Language["Czech"] = "Czech";
    Language["Danish"] = "Danish";
    Language["Dutch"] = "Dutch";
    Language["Esperanto"] = "Esperanto";
    Language["Estonian"] = "Estonian";
    Language["Filipino"] = "Filipino";
    Language["Finnish"] = "Finnish";
    Language["French"] = "French";
    Language["Frisian"] = "Frisian";
    Language["Galician"] = "Galician";
    Language["Georgian"] = "Georgian";
    Language["German"] = "German";
    Language["Greek"] = "Greek";
    Language["Gujarati"] = "Gujarati";
    Language["HaitianCreole"] = "Haitian Creole";
    Language["Hausa"] = "Hausa";
    Language["Hebrew"] = "Hebrew";
    Language["Hindi"] = "Hindi";
    Language["Hmong"] = "Hmong";
    Language["Hungarian"] = "Hungarian";
    Language["Icelandic"] = "Icelandic";
    Language["Igbo"] = "Igbo";
    Language["Indonesian"] = "Indonesian";
    Language["Irish"] = "Irish";
    Language["Italian"] = "Italian";
    Language["Japanese"] = "Japanese";
    Language["Javanese"] = "Javanese";
    Language["Kannada"] = "Kannada";
    Language["Kazakh"] = "Kazakh";
    Language["Khmer"] = "Khmer";
    Language["Korean"] = "Korean";
    Language["Kurdish"] = "Kurdish";
    Language["Kyrgyz"] = "Kyrgyz";
    Language["Lao"] = "Lao";
    Language["Latin"] = "Latin";
    Language["Latvian"] = "Latvian";
    Language["Lithuanian"] = "Lithuanian";
    Language["Luxembourgish"] = "Luxembourgish";
    Language["Macedonian"] = "Macedonian";
    Language["Malagasy"] = "Malagasy";
    Language["Malay"] = "Malay";
    Language["Malayalam"] = "Malayalam";
    Language["Maltese"] = "Maltese";
    Language["Maori"] = "Maori";
    Language["Marathi"] = "Marathi";
    Language["Mongolian"] = "Mongolian";
    Language["Nepali"] = "Nepali";
    Language["Norwegian"] = "Norwegian";
    Language["Pashto"] = "Pashto";
    Language["Persian"] = "Persian";
    Language["Polish"] = "Polish";
    Language["Portuguese"] = "Portuguese";
    Language["Punjabi"] = "Punjabi";
    Language["Romanian"] = "Romanian";
    Language["Russian"] = "Russian";
    Language["Samoan"] = "Samoan";
    Language["ScotsGaelic"] = "Scots Gaelic";
    Language["Serbian"] = "Serbian";
    Language["Sesotho"] = "Sesotho";
    Language["Shona"] = "Shona";
    Language["Sindhi"] = "Sindhi";
    Language["Sinhala"] = "Sinhala";
    Language["Slovak"] = "Slovak";
    Language["Slovenian"] = "Slovenian";
    Language["Somali"] = "Somali";
    Language["Spanish"] = "Spanish";
    Language["Sundanese"] = "Sundanese";
    Language["Swahili"] = "Swahili";
    Language["Swedish"] = "Swedish";
    Language["Tajik"] = "Tajik";
    Language["Tamil"] = "Tamil";
    Language["Telugu"] = "Telugu";
    Language["Thai"] = "Thai";
    Language["Turkish"] = "Turkish";
    Language["Turkmen"] = "Turkmen";
    Language["Ukrainian"] = "Ukrainian";
    Language["Urdu"] = "Urdu";
    Language["Uzbek"] = "Uzbek";
    Language["Vietnamese"] = "Vietnamese";
    Language["Welsh"] = "Welsh";
    Language["Xhosa"] = "Xhosa";
    Language["Yiddish"] = "Yiddish";
    Language["Yoruba"] = "Yoruba";
    Language["Zulu"] = "Zulu";
})(Language = exports.Language || (exports.Language = {}));
var ContentCategory;
(function (ContentCategory) {
    ContentCategory["Travel"] = "Travel";
    ContentCategory["Food"] = "Food";
    ContentCategory["Lifestyle"] = "Lifestyle";
    ContentCategory["FashionAndBeauty"] = "Fashion and Beauty";
    ContentCategory["FitnessAndWellness"] = "Fitness and Wellness";
    ContentCategory["Cooking"] = "Cooking";
    ContentCategory["ParentingAndFamily"] = "Parenting and Family";
    ContentCategory["TechAndGadgets"] = "Tech and Gadgets";
    ContentCategory["Gaming"] = "Gaming";
    ContentCategory["MotivationAndSelfImprovement"] = "Motivation and Self-Improvement";
    ContentCategory["ComedyAndEntertainment"] = "Comedy and Entertainment";
    ContentCategory["ArtAndCreativity"] = "Art and Creativity";
    ContentCategory["BooksAndLiterature"] = "Books and Literature";
    ContentCategory["MusicAndPerformingArts"] = "Music and Performing Arts";
    ContentCategory["EnvironmentalAndSustainability"] = "Environmental and Sustainability";
    ContentCategory["EducationAndLearning"] = "Education and Learning";
    ContentCategory["PetsAndAnimals"] = "Pets and Animals";
    ContentCategory["TechnologyAndScience"] = "Technology and Science";
    ContentCategory["Other"] = "Other";
})(ContentCategory = exports.ContentCategory || (exports.ContentCategory = {}));
var TravelInterest;
(function (TravelInterest) {
    TravelInterest["AdventureTravel"] = "Adventure Travel";
    TravelInterest["LuxuryTravel"] = "Luxury Travel";
    TravelInterest["SoloTravel"] = "Solo Travel";
    TravelInterest["BudgetTravel"] = "Budget Travel";
    TravelInterest["CulturalExploration"] = "Cultural Exploration";
    TravelInterest["FoodAndCulinaryTravel"] = "Food and Culinary Travel";
    TravelInterest["SustainableAndEcoFriendlyTravel"] = "Sustainable and Eco-Friendly Travel";
    TravelInterest["WellnessAndRetreatTravel"] = "Wellness and Retreat Travel";
    TravelInterest["HistoricalAndCulturalSites"] = "Historical and Cultural Sites";
    TravelInterest["NatureAndWildlife"] = "Nature and Wildlife";
    TravelInterest["UrbanExploration"] = "Urban Exploration";
    TravelInterest["RoadTrips"] = "Road Trips";
    TravelInterest["BeachAndIslandTravel"] = "Beach and Island Travel";
    TravelInterest["FamilyFriendlyTravel"] = "Family-Friendly Travel";
    TravelInterest["PhotographyAndVisualStorytelling"] = "Photography and Visual Storytelling";
    TravelInterest["AdventureSports"] = "Adventure Sports";
    TravelInterest["LocalExperiences"] = "Local Experiences";
    TravelInterest["VolunteerAndHumanitarianTravel"] = "Volunteer and Humanitarian Travel";
    TravelInterest["FestivalAndEventTravel"] = "Festival and Event Travel";
    TravelInterest["NomadicTravel"] = "Nomadic Travel";
    TravelInterest["TrainAndRailTravel"] = "Train and Rail Travel";
    TravelInterest["SpiritualAndReligiousTravel"] = "Spiritual and Religious Travel";
})(TravelInterest = exports.TravelInterest || (exports.TravelInterest = {}));
var PayoutAccountType;
(function (PayoutAccountType) {
    PayoutAccountType["Stripe"] = "stripe";
    PayoutAccountType["Internal"] = "internal";
})(PayoutAccountType = exports.PayoutAccountType || (exports.PayoutAccountType = {}));
const isProfileComplete = (planner) => {
    var _a, _b, _c;
    return (planner === null || planner === void 0 ? void 0 : planner.name) &&
        ((_a = planner === null || planner === void 0 ? void 0 : planner.languages) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
        (planner === null || planner === void 0 ? void 0 : planner.country) &&
        (planner === null || planner === void 0 ? void 0 : planner.tagLine) &&
        (planner === null || planner === void 0 ? void 0 : planner.bio) &&
        ((_b = planner === null || planner === void 0 ? void 0 : planner.contentCategories) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
        ((_c = planner === null || planner === void 0 ? void 0 : planner.travelInterests) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
        (planner === null || planner === void 0 ? void 0 : planner.imageSrc) &&
        (planner === null || planner === void 0 ? void 0 : planner.coverImageSrc) &&
        Object.values((planner === null || planner === void 0 ? void 0 : planner.socialMedia) || {}).some((v) => !!v);
};
exports.isProfileComplete = isProfileComplete;
